import React from 'react';
import { thankYouData } from '../data/mock';
import { CheckCircle, ArrowRight } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_flats-clean-service/artifacts/2b1a8yim_Screenshot_20260123_012606_Drive.jpg";

const ThankYouPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Logo Header */}
      <header className="w-full py-4 px-6 bg-white border-b border-gray-100">
        <div className="max-w-6xl mx-auto">
          <img 
            src={LOGO_URL} 
            alt="Just Cleaned" 
            className="h-12 md:h-14 w-auto object-contain"
          />
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-6 py-16">
        <div className="max-w-lg w-full text-center">
          {/* Success Icon */}
          <div className="mb-8">
            <div className="w-20 h-20 bg-[#00c853]/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-10 h-10 text-[#00c853]" />
            </div>
            
            {/* Main Heading */}
            <h1 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-4">
              {thankYouData.title}
            </h1>
            
            {/* Subtext */}
            <p className="text-gray-600 text-lg leading-relaxed">
              {thankYouData.message}
            </p>
          </div>

          {/* What Happens Next Block */}
          <div className="bg-white rounded-xl p-8 shadow-sm border border-gray-100 mb-6">
            <div className="flex items-center justify-center gap-2 mb-4">
              <ArrowRight className="w-5 h-5 text-[#1a1f4e]" />
              <h2 className="text-lg font-semibold text-gray-900">
                {thankYouData.whatHappensNext.title}
              </h2>
            </div>
            <p className="text-gray-600 leading-relaxed">
              {thankYouData.whatHappensNext.body}
            </p>
          </div>

          {/* Secondary Reassurance */}
          <p className="text-gray-400 text-sm">
            {thankYouData.secondaryReassurance}
          </p>
        </div>
      </main>

      {/* Minimal Footer */}
      <footer className="py-6 text-center text-gray-500 text-sm">
        <p>Just Cleaned • Communal block cleaning</p>
      </footer>
    </div>
  );
};

export default ThankYouPage;
